<template>
  <div class="profiles-constructor">
    <el-col :span="11">
      <r-text type="caption">{{ $t("tree:title-profile") }}</r-text>
      <profile-tree :edit-mode="true" module="constructorTree" />
    </el-col>
    <el-col :span="2" class="profiles-constructor__tools">
      <div class="profiles-constructor__tools-container">
        <el-tooltip
          :open-delay="500"
          :content="`${$t('tree:ds-add')}`"
          placement="top"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            :class="[isActive.left, 'r-button']"
            size="mini"
            circle
            @click="addObject"
          >
          </el-button>
        </el-tooltip>
        <el-tooltip
          :open-delay="500"
          :content="`${$t('tree:ds-remove')}`"
          placement="bottom"
        >
          <el-button
            type="danger"
            icon="el-icon-minus"
            :class="[isActive.right, 'r-button']"
            size="mini"
            circle
            @click="deleteObject"
          >
          </el-button>
        </el-tooltip>
      </div>
    </el-col>
    <el-col :span="11">
      <r-text type="caption">{{ $t("tree:title-dsTree") }}</r-text>
      <ds-tree module="constructorDsTree" :edit-mode="true" />
    </el-col>
  </div>
</template>

<script>
import profileTree from "@/components/profiles-tree/profiles-tree.vue";
import dsTree from "@/components/ds-tree/ds-tree.vue";

import { notifyFactory } from "@/utils";
import cloneDeep from "lodash.clonedeep";

export default {
  components: {
    profileTree,
    dsTree
  },
  data() {
    return {
      checkedData: {
        add: [],
        profile: []
      },
      isActive: {
        left: "disabled",
        right: "disabled"
      }
    };
  },
  watch: {
    "$store.state.profiles.profileConstructor.checkedData": {
      handler: function(val) {
        this.isActive.left = !val.length ? "disabled" : "main";
        this.checkedData.add = val;
      },
      deep: true,
      immediate: true
    },
    "$store.state.profiles.profileConstructor.checkedDataProfile": {
      handler: function(val) {
        this.isActive.right = !val.length ? "disabled" : "danger";
        this.checkedData.profile = val;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    currentProfileId() {
      return this.$store.state.profiles.profileConstructor.profileId;
    }
  },
  methods: {
    async addObject() {
      const { data } = await this.$store.dispatch("REQUEST", {
        url: `profile_tree?profile_id=${this.currentProfileId}`
      });
      if (this.isActive.left !== "main") return;
      let profileTree = [];

      this.checkedData.add.forEach(e => {
        let isCopy = false;
        let lastIndex;
        let name = cloneDeep(e.name);
        isCopy = data.profile_trees.find(n => {
          if (n.name === name) return true;
        });
        lastIndex =
          Math.max(
            ...data.profile_trees
              .map(v => v.name)
              .map(x => x.match(/копия_\d+/))
              .map(x => x && parseInt(x[0].replace("копия_", "")))
          ) + 1;

        name = isCopy ? `${name} (копия_${lastIndex})` : name;

        if (!e.parent_id) {
          profileTree.push({
            name: name,
            source_id: e.id,
            children: []
          });
        } else {
          profileTree.map(n => {
            if (n.source_id !== e.parent_id) {
              return n;
            } else {
              return n.children.push({
                name: name,
                source_id: e.id,
                children: []
              });
            }
          });
        }
      });

      const options = {
        url: "user/profile?",
        data: { id: this.currentProfileId, profile_trees: profileTree }
      };
      const currentProfileId = this.$store.state.profiles.currentProfile.id;

      try {
        await this.$store.dispatch("POST_REQUEST", options);
        let user = await this.$store.dispatch("REQUEST", { url: `user` });
        if (this.currentProfileId === currentProfileId) {
          this.$store.commit("SET_CURRENT_PROFILE", user.data.current_profile);
        }
        this.$store.commit("SET_PROFILES_TREE", user.data.user_profiles);
        this.$store.commit("CLEAR_CHECKED_DATA");
        this.$store.commit("PROFILE_TREE_UPDATED", {
          action: "toggle",
          value: true
        });
        this.checkedData.add = [];
        const title = this.$t("profiles-constructor:notify:success-title");
        const message = this.$t("profiles-constructor:notify:success");
        this.$notify(notifyFactory("info", title, message));
      } catch (e) {
        console.log(e);
      }
    },
    async deleteObject() {
      if (this.isActive.right !== "danger") return;
      let deleteFromTree = [];

      this.checkedData.profile.forEach(e => {
        deleteFromTree.push({
          id: e.id,
          disabled: true
        });
      });

      const options = {
        url: "user/profile?",
        data: { id: this.currentProfileId, profile_trees: deleteFromTree }
      };
      const currentProfileId = this.$store.state.profiles.currentProfile.id;
      try {
        await this.$store.dispatch("POST_REQUEST", options);
        let user = await this.$store.dispatch("REQUEST", { url: `user` });
        if (this.currentProfileId === currentProfileId) {
          this.$store.commit("SET_CURRENT_PROFILE", user.data.current_profile);
        }
        this.$store.commit("SET_PROFILES_TREE", user.data.user_profiles);
        this.$store.commit("CLEAR_CHECKED_DATA", true);
        this.$store.commit("PROFILE_TREE_UPDATED", {
          action: "toggle",
          value: true
        });
        this.checkedData.profile = [];
        const title = this.$t("profiles-constructor:notify:success-title");
        const message = this.$t("profiles-constructor:notify:success");
        this.$notify(notifyFactory("info", title, message));
      } catch (e) {
        console.log(e);
      }
    }
  },
  beforeDestroy() {
    this.$store.commit("CLEAR_CHECKED_DATA");
    this.$store.commit("CLEAR_CHECKED_DATA", true);
  }
};
</script>

<style lang="scss">
.profiles-constructor {
  width: 100%;
  height: calc(100% - 80px);
  display: flex;
  overflow: hidden;
  min-height: 250px;
  max-height: 1000px;
  &__tools {
    display: flex;
    &-container {
      height: calc(100% - 40px);
      margin: 0 10px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      .el-button {
        margin-left: 0 !important;
        &:first-child {
          margin-bottom: 8px;
        }
      }
    }
  }
  .ds-tree,
  .profile-tree {
    height: calc(100% - 20px);
  }
  .el-col {
    &:first-child,
    &:last-child {
      padding: 4px;
      border: 1px solid;
      border-radius: var(--border-radius);
      background-color: var(--modal_overlay) !important;
      box-sizing: border-box;
    }
    button {
      width: 32px !important;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "tree:title-profile": "Источники данных выбранного профиля",
    "tree:title-dsTree": "Доступные источники данных",

    "tree:ds-add": "Добавить выбранные объекты",
    "tree:ds-remove": "Убрать выбранные объекты",

    "profiles-constructor:notify:success-title": "Уведомление",
    "profiles-constructor:notify:success": "Профиль успешно изменен!"
  },
  "en": {
    "tree:title-profile": "Selected profile data sources",
    "tree:title-dsTree": "Available data sources",

    "tree:ds-add": "Add selected objects",
    "tree:ds-remove": "Remove selected objects",

    "profiles-constructor:notify:success-title": "Notification",
    "profiles-constructor:notify:success": "Profile successfully changed!"
  }
}
</i18n>
